import type { ReactNode } from "react";

import page from "./actors/actors.module.css";
import create from "./create/create.module.css";

interface ProPageProps {
  /** The page's h1 and its line under it; a page that draws its own h1 leaves them out. */
  title?: string | undefined;
  lede?: string | undefined;
  children: ReactNode;
}

/**
 * A redesigned page's body in Pro's frame: its padding, and the title and line every Pro page
 * opens with. `app/` draws another area's page in it (spec ui-perf/ui-switch-classic-simple-pro,
 * PR e5b).
 */
export function ProPage({ title, lede, children }: ProPageProps) {
  return (
    <div className={create.page}>
      {title === undefined ? null : (
        <div className={page.head}>
          <div className={page.titles}>
            <h1 className={page.title}>{title}</h1>
            {lede === undefined ? null : <p className={page.lede}>{lede}</p>}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
